"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Generic = void 0;
/**
 * A class that contains various utility functions for making API calls, handling input events,
 * and more.
 * @class
 */
var Generic = {
    /**
  * Capitalizes the first letter of a word and lowercases the rest.
  * @param {string} word - The word to capitalize.
  * @returns {string} The capitalized word.
  * @example
  * const result = capitalize("hello world");
  * console.log(result); // "Hello world"
  */
    capitalize: function (word) {
        if (!word)
            return word;
        return word[0].toUpperCase() + word.substr(1).toLowerCase();
    },
    /**
     * Converts a string from snake_case to camelCase.
     * @param {string} str - The string to convert.
     * @returns {string} The camelCase string.
     * @example
     * const result = camelize("hello_world");
     * console.log(result); // "helloWorld"
     */
    camelize: function (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0)
                return ""; // or if (/\s+/.test(match)) for white spaces
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    },
    extractTextFromComponent: function (component) {
        var _this = this;
        if (typeof component === 'string' || typeof component === 'number') {
            return component.toString();
        }
        if (!component || !component.props) {
            return '';
        }
        // Check if the component is an EloiseWidget and skip if it is
        if (component.type && component.type.name === 'EloiseWidget') {
            return '';
        }
        if (component.props.children) {
            if (Array.isArray(component.props.children)) {
                return component.props.children
                    .map(function (child) { return _this.extractTextFromComponent(child); })
                    .join(' ');
            }
            return this.extractTextFromComponent(component.props.children);
        }
        return '';
    },
    /**
     * Updates a state variable with the value of an input event.
     * @param {React.ChangeEvent<HTMLInputElement>} event - The input event.
     * @param {Function} setter - The state setter function.
     * @example
     * const [name, setName] = useState("");
     * const handleInputChange = (e) => {
     *   inputHandler(e, setName);
     * };
     */
    inputHandler: function (event, setter) {
        var enteredName = event.target.value;
        setter(enteredName);
    },
    /**
     * Returns a random element from an array.
     * @param {any[]} arr - The array to select from.
     * @returns {any} The randomly selected element.
     * @example
     * const options = ["option1", "option2", "option3"];
     * const result = getRandom(options);
     * console.log(result); // "option2" (or another random option)
     */
    getRandom: function (arr) {
        var ots = arr[Math.floor(Math.random() * arr.length)];
        return ots;
    },
    shuffleArray: function (array) {
        var _a;
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            _a = [array[j], array[i]], array[i] = _a[0], array[j] = _a[1];
        }
        return array;
    },
    /**
     * Retrieves a list of permissions from the server.
     * @returns {Promise<string[]>} A promise that resolves to an array of permission names.
     * @example
     * const permissions = await getPerms();
     * console.log(permissions); // ["read", "write", "admin"]
     */
    getPerms: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiCall("perms")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    /**
     * Sends a password reset request to the server.
     * @returns {Promise<boolean>} A promise that resolves to true if the request was successful.
     * @example
     * const success = await resetPassword();
     * console.log(success); // true if the request was successful
     */
    resetPassword: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiCall("resetPassword")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    /**
     * Updates the current user's profile with the given data.
     * @param {Object} update - An object containing the updated user data.
     * @returns {Promise<boolean>} A promise that resolves to true if the update was successful.
     * @example
     * const update = { firstName: "John", lastName: "Doe" };
     * const success = await updateUser(update);
     * console.log(success); // true if the update was successful
     */
    updateUser: function (update) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiCall("user", update)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    /**
     * Takes a lower camel case string and returns a formatted string with spaces between words.
     *
     * @param {string} str - The string to format.
     * @returns {string} A formatted string with spaces between words.
     *
     * @example
     *
     * const formattedString = formatCamelCaseString("firstName");
     * console.log(formattedString); // "First Name"
     */
    formatCamelCaseString: function (str) {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
            .replace(/^./, function (s) { return s.toUpperCase(); });
    },
};
exports.Generic = Generic;
